import { defineMessages } from 'react-intl';

type MessageKeys = 'newChatButtonLabel' | 'noResults' | 'accessibleSearchResults';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		newChatButtonLabel: {
			id: 'ai-mate.all-chats-view.new-chat-button-label',
			defaultMessage: 'New chat',
			description:
				'Button label displayed on the new chat button in the chat conversation list view within the AI conversation interface. Shown as the text on a button. When clicked, it starts a new conversation session, clearing the current chat history. The purpose is to provide users with a clear way to begin a fresh conversation with the AI assistant from the conversation list view.',
		},
		noResults: {
			id: 'ai-mate.all-chats-view.no-results',
			defaultMessage: 'No results',
			description: 'Message to display when no agents are found',
		},
		accessibleSearchResults: {
			id: 'conversation-assistant-ui-components.common.chat-conversation-list-refresh.accessibleSearchResults',
			// eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
			defaultMessage: '{results, plural, =1 {1 result found} other {# results found}}',
			description:
				'Accessibility announcement text displayed or announced by screen readers in the refreshed chat conversation list view when search results are updated. The results placeholder is the number of matching conversations.',
		},
	});

export default message;
